module.exports = __webpack_public_path__ + "static/media/logo.f8f346a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layout/logo.svg
// module id = 1556
// module chunks = 0